'use strict';

var numeral = require('numeral');

Number.prototype.format = function(format) {
    return numeral(this).format(format || '0,0.00');
};

module.exports = {};



// WEBPACK FOOTER //
// ./app/helpers/Numbers.js